module.exports = __webpack_public_path__ + "static/img/02.d5271de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024111/02.png
// module id = 2+in
// module chunks = 0